import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";


export const countPendingWithdrawals = async () => {
    return await customFetch(`v1/withdrawal/count-pending`, {
      method: "GET",
    });
  };
  
  
export const getWithdrawals = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  
  return await customFetch(`v1/withdrawal?${queryParams}`, {
    method: "GET",
  });
};


export const getWithdrawalDetail = async (id: string) => {
  return await customFetch(`v1/withdrawal/${id}`, {
    method: "GET",
  });
};
export const settlementWithdrawalDetail = async (id: string) => {
  return await customFetch(`v1/withdrawal/${id}/settlement`, {
    method: "PUT",
  });
};

